import type { StateCreator } from 'zustand';
import type { AppStore, StudentsSlice, Student } from '../types';

const initialStudentsState = {
  students: [],
  selectedStudentId: null,
  isLoading: false,
  error: null,
};

export const createStudentsSlice: StateCreator<AppStore, [], [], StudentsSlice> = (set) => ({
  ...initialStudentsState,

  setStudents: (students: Student[]) =>
    set({ students }),

  addStudent: (student: Student) =>
    set((state) => ({
      students: [...state.students, student],
    })),

  updateStudent: (id: string, updates: Partial<Student>) =>
    set((state) => ({
      students: state.students.map((student) =>
        student.id === id ? { ...student, ...updates } : student
      ),
    })),

  removeStudent: (id: string) =>
    set((state) => ({
      students: state.students.filter((student) => student.id !== id),
      selectedStudentId: state.selectedStudentId === id ? null : state.selectedStudentId,
    })),

  selectStudent: (id: string | null) =>
    set({ selectedStudentId: id }),

  setStudentsLoading: (isLoading: boolean) =>
    set({ isLoading }),

  setStudentsError: (error: string | null) =>
    set({ error }),
});
